<template>
  <div id="'chart-container'">
    <apexchart
      type="line"
      width="100%"
      height="250px"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
export default {
  name: "LineChartB",
  props: {
    whatsapp: {
      type: Object,
      required: true,
    },
    widget: {
      type: Object,
      required: true,
    },
    totalDays: {
      type: Number,
      required: true,
    },
    isDatePickerChanged: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      options: {
        chart: {
          background: "#385f73",
          foreColor: "#ccc",
          toolbar: {
            show: false,
          },
        },
        xaxis: {
          categories: this.labels(),
        },
        stroke: {
          curve: "smooth",
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#00bb2d", "#93D3FF"],
      },
      series: [
        {
          name: "WhatsApp",
          data: this.whatsapp.byDay,
        },
        {
          name: "Widget",
          data: this.widget.byDay,
        },
      ],
    };
  },
  watch: {
    isDatePickerChanged: {
      immediate: true,
       handler (value) {
        console.log('Aux Value: ' + value)
        this.updateChart()
      }
    }
  },
  methods: {
    labels() {
      let labels = [];
      for (let index = 1; index <= this.totalDays; index++) {
        labels.push(`-${index}-`);
      }
      return labels;
    },
    updateChart() {
      console.log("update function");
      // In the same way, you update the series option
      this.series = [
        {
          name: "WhatsApp",
          data: this.whatsapp.byDay,
        },
        {
          name: "Widget",
          data: this.widget.byDay,
        },
      ];
    },
  },
};
</script>

<style>
</style>